import { z } from 'zod'
import { FieldSchemaSchema } from './schema'

export const SchemaMetaSchema = z.object({
  version: z.string(),
  fields: z.array(FieldSchemaSchema),
})
export type SchemaMeta = z.infer<typeof SchemaMetaSchema>

export const CapabilitiesSchema = z.object({
  features: z.array(z.string()),
  tier: z.enum(['free', 'pro', 'enterprise']),
})
export type Capabilities = z.infer<typeof CapabilitiesSchema>

export const SessionUserSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  role: z.string().optional(),
  email: z.string().email().optional(),
})
export type SessionUser = z.infer<typeof SessionUserSchema>

export const SessionContextSchema = z.object({
  schemaMeta: SchemaMetaSchema,
  capabilities: CapabilitiesSchema,
  locale: z.string(),
  user: SessionUserSchema.optional(),
  tenantId: z.string().optional(),
})
export type SessionContext = z.infer<typeof SessionContextSchema>
